import React from "react";
import { FormattedMessage } from "react-intl";
import { Block, FirstFreeText, Toggle } from "./CategoryLimitsField.styles";
import { categoryLimitsMessages } from "./CategoryLimitsField.messages";
import { ExtrasChecklist } from "./ExtrasChecklist";
import { FieldErrors } from "./FieldErrors";
import { LimitSelect } from "./LimitSelect";
import { CategoryLimitBlockModel } from "./useCategoryLimitsField";

/** One category block: toggle, and when on, the limits and the extras list. */
export function CategoryLimitBlock({ view, actions }: CategoryLimitBlockModel) {
  return (
    <Block $enabled={view.enabled} data-testid={`${view.baseId}-block`}>
      <Toggle className="custom-control custom-switch">
        <input
          type="checkbox"
          role="switch"
          className="custom-control-input"
          id={view.toggleId}
          checked={view.enabled}
          onChange={event => actions.onToggle(event.target.checked)}
        />
        <label className="custom-control-label" htmlFor={view.toggleId}>
          <FormattedMessage
            {...categoryLimitsMessages.toggle}
            values={{ category: view.categoryPlural }}
          />
        </label>
      </Toggle>
      {view.enabled && (
        <div className="mt-3">
          <FieldErrors id={`${view.baseId}-error`} messages={view.blockErrors} />
          <LimitSelect
            view={view.included}
            label={categoryLimitsMessages.included}
            help={categoryLimitsMessages.includedHelp}
            accommodation={view.accommodation}
            onChange={actions.onIncludedChange}
          />
          <LimitSelect
            view={view.max}
            label={categoryLimitsMessages.max}
            help={categoryLimitsMessages.maxHelp}
            accommodation={view.accommodation}
            onChange={actions.onMaxChange}
          />
          <div role="group" aria-labelledby={view.extrasTitleId}>
            <div id={view.extrasTitleId} className="mb-1">
              <FormattedMessage
                {...categoryLimitsMessages.extrasTitle}
                values={{ category: view.categoryPlural }}
              />
            </div>
            <ExtrasChecklist
              lines={view.lines}
              describedBy={view.extrasErrors.length > 0 ? view.extrasErrorId : undefined}
              onTick={actions.onTick}
            />
            <FieldErrors id={view.extrasErrorId} messages={view.extrasErrors} />
            {view.firstFreeExtra && (
              <FirstFreeText data-testid={`${view.baseId}-first-free`}>
                <FormattedMessage
                  {...categoryLimitsMessages.firstFree}
                  values={{
                    category: view.categorySingular,
                    extra: <strong>{view.firstFreeExtra}</strong>,
                  }}
                />
              </FirstFreeText>
            )}
          </div>
        </div>
      )}
    </Block>
  );
}
